var map = {
	"./Secure-Connection.svg": "c591",
	"./amex.svg": "a654",
	"./chat-close.svg": "3b2d",
	"./chat.svg": "10b7",
	"./contact-support-icon.svg": "2ed1",
	"./cp-home.svg": "a81a",
	"./cp-order-history.svg": "f60b",
	"./cp-order-list.svg": "5785",
	"./cp-payment-info.svg": "107a",
	"./cp-personal-info.svg": "614b",
	"./credit-card.svg": "03ba",
	"./current.svg": "8866",
	"./delivery.svg": "35eb",
	"./diners.svg": "ea45",
	"./discover.svg": "3478",
	"./help.svg": "c3ea",
	"./jcb.svg": "6d0f",
	"./loader.svg": "a72f",
	"./lock.svg": "d3cc",
	"./mastercard.svg": "2dac",
	"./menu.svg": "c8fa",
	"./profile.svg": "c768",
	"./sad.svg": "5851",
	"./solvpath.svg": "1222",
	"./visa.svg": "f73a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";